// extracted by mini-css-extract-plugin
module.exports = {"mobile-number-form":"mobile-number-form_mobile-number-form__5TtzI"};